export const OPTIONS_FILTER_CHART = [{
        key: 'daily',
        label: '今日'
    }, {
        key: 'weekly',
        label: '今週'
    }, {
        key: 'monthly',
        label: '今月'
    }, {
        key: 'yearly',
        label: '今年'
    }];
export const OPTIONS_PERIOD_MODE_TRAFFIC_SOURCE = [{
        key: 'this_week',
        label: '週別'
    }, {
        key: 'this_month',
        label: '月別'
    }, {
        key: 'this_year',
        label: '年別'
    }];
export const OPTION_PAYMENT_STATUS = [{
        value: 0,
        label: '登録者（決済前で止まっている）'
    }, {
        value: 1,
        label: '有効'
    },
    // { value: 2, label: '有効期限内'},
    {
        value: 3,
        label: '有効期限切れ'
    }, {
        value: 4,
        label: '課金解約済'
    }];
export const LABEL_MAP_PAYMENT_STATUS = OPTION_PAYMENT_STATUS.reduce((acc, item) => {
    acc[item.value] = item.label;
    return acc;
}, {});
export const OPTION_PAYMENT_STATUS_SELECT = OPTION_PAYMENT_STATUS.map(item => ({
    value: item.value,
    label: item.label
}));
export const OPTION_USER_STATUS = [{
        value: 0,
        label: '未設定'
    }, {
        value: 1,
        label: '18歳未満'
    }, {
        value: 2,
        label: 'DM不可'
    }, {
        value: 3,
        label: 'DM返信なし'
    }, {
        value: 4,
        label: 'アクティブ'
    }, {
        value: 5,
        label: '一時停止'
    }, {
        value: 6,
        label: '検索不可'
    }, {
        value: 7,
        label: '再登録予定'
    }, {
        value: 8,
        label: '再登録予定 一時停止'
    }, {
        value: 9,
        label: '削除希望'
    }, {
        value: 10,
        label: '退会'
    }, {
        value: 11,
        label: '退会フォーム送信済'
    }];
export const LABEL_MAP_USER_STATUS = OPTION_USER_STATUS.reduce((acc, item) => {
    acc[item.value] = item.label;
    return acc;
}, {});
export const OPTION_USER_STATUS_SELECT = OPTION_USER_STATUS.map(item => ({
    value: item.value,
    label: item.label
}));
export const OPTION_REVIEW = [{
        key: 'form_dm',
        label: 'DM対応'
    }, {
        key: 'form_atomosphere',
        label: '第一印象'
    }, {
        key: 'form_profile',
        label: 'フォームと実際のギャップ'
    }, {
        key: 'form_tongue',
        label: '舌技'
    }, {
        key: 'form_hand',
        label: '手技'
    }, {
        key: 'form_waist',
        label: '腰使い'
    }, {
        key: 'form_afterplay',
        label: '前戯'
    }, {
        key: 'form_foreplay_duration',
        label: '前戯時間'
    }, {
        key: 'form_sex_duration',
        label: '挿入時間'
    }, {
        key: 'form_afterplay_duration',
        label: '後戯時間'
    }, {
        key: 'form_replay',
        label: 'また会いたい？'
    }];
export const LABEL_MAP_REVIEW = OPTION_REVIEW.reduce((acc, item) => {
    acc[item.key] = item.label;
    return acc;
}, {});
export const OPTION_REVIEW_SELECT = OPTION_REVIEW.map(item => ({
    value: item.key,
    label: item.label
}));
export const BANNER_QUERY_KEY = ['admin-ad-banners'];
export const DIAGNOSIS_ICON_QUERY_KEY = ['admin-diagnosis-icons'];
export const NEW_RANK_CONDITION_QUERY_KEY = ['admin-new-rank-conditions'];
export const RANKING_LEVELS_QUERY_KEY = ['admin-ranking-levels'];
export const STI_DOCUMENT_QUERY_KEY = ['admin-sti-documents'];
export const DATE_POST_QUERY_KEY = ['admin-date-posts'];
export const ADMIN_MESSAGES_QUERY_KEY = ['admin-conversation-messages'];
export const DATE_POST_STATUS_FILTER_OPTIONS = [{
        label: 'すべて',
        value: 'all'
    }, {
        label: '掲載中',
        value: 'live'
    }, {
        label: '休止',
        value: 'paused'
    }, {
        label: '期限切れ',
        value: 'expired'
    }, {
        label: '削除',
        value: 'deleted'
    }];
export const DATE_POST_STATUS_LABEL_MAP = {
    live: '掲載中',
    paused: '休止',
    expired: '期限切れ',
    deleted: '削除'
};
export const DATE_POST_STATUS_COLOR_MAP = {
    live: 'green',
    paused: 'gold',
    expired: 'default',
    deleted: 'red'
};
export const STI_STATUS_LABEL_MAP = {
    pending: '審査中',
    approved: '承認済み',
    rejected: '却下',
    expired: '期限切れ',
    superseded: '置換済み'
};
export const STI_STATUS_COLOR_MAP = {
    pending: 'gold',
    approved: 'green',
    rejected: 'red',
    expired: 'default',
    superseded: 'default'
};
export const STI_STATUS_FILTER_OPTIONS = [{
        label: '審査中',
        value: 'pending'
    }, {
        label: '承認済み',
        value: 'approved'
    }, {
        label: '却下',
        value: 'rejected'
    }, {
        label: '期限切れ',
        value: 'expired'
    }, {
        label: 'すべて',
        value: 'all'
    }];
export const SECTION_OPTIONS = [{
        label: 'ヘッダー',
        value: 1
    }, {
        label: 'マイページ（お得情報）',
        value: 2
    }, {
        label: 'フッター',
        value: 3
    }];
export const POSITION_LABEL_MAP = {
    1: 'ヘッダー',
    2: 'マイページ（お得情報）',
    3: 'フッター'
};
export const STATUS_LABEL_MAP = {
    active: '掲載中',
    inactive: '停止中'
};
export const STATUS_COLOR_MAP = {
    active: 'green',
    inactive: 'red'
};
export const DEFAULT_FORM_VALUES = {
    title: '',
    mediaType: 'image',
    imageLinkUrl: '',
    videoLinkUrl: '',
    position: 2,
    active: true
};
